// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import React, { useEffect, useRef, useState } from 'react';
import { S } from './styles';

interface DropupProps<T> {
  initialSelected: T;
  options: readonly T[];
  unit?: string;
  hoverTriggered?: boolean;
  customTriggerButton?: (handleTrigger: () => void) => JSX.Element;
  customLabelRenderFunction?: (option:T) => JSX.Element;
  handleChange: (option:T) => void;
}

function Dropup<T>({
  options,
  unit,
  handleChange,
  customTriggerButton,
  customLabelRenderFunction,
  hoverTriggered = false,
  initialSelected
}:DropupProps<T>):JSX.Element {
  const [currentSelected, setCurrentSelected] = useState<T>(initialSelected);
  const [isDropupShow, setIsDropupShow] = useState<boolean>(false);
  const DropupBoxRef = useRef<HTMLDivElement>(null);
  const CustomTriggerButtonWrapperRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    setCurrentSelected(initialSelected);
  }, [initialSelected]);

  const toggleShowDropup = () => {
    if (hoverTriggered) {
      setIsDropupShow(true)
    } else {
      setIsDropupShow(!isDropupShow)
    }
    window.addEventListener('click', handleBlur, true);
  }

  const handleEnter = (option:T) => setCurrentSelected(option);
  const handleLeave = () => setCurrentSelected(initialSelected);

  const handleBlur = (event: any) => {
    const ref = DropupBoxRef.current;
    if (!ref?.contains(event.target)) {
      if (!CustomTriggerButtonWrapperRef.current?.contains(event.target)) {
        event.stopPropagation();
      }
      setIsDropupShow(false);
    }
    window.removeEventListener('click', handleBlur, true);
  }

  const handleSubmitChange = (option:T) => {
    setCurrentSelected(option);
    setIsDropupShow(false);
    handleChange(option);
  }

  return (
    <S.DropupWrapper>
      {isDropupShow && <S.DropupContainer ref={DropupBoxRef}>
        {
          options.map((option:T, index: number) =>
            <S.DropupOption
              key={index}
              isUsed={currentSelected === option}
              onMouseEnter={() => handleEnter(option)}
              onMouseLeave={handleLeave}
              onClick={() => handleSubmitChange(option)}
            >
              {customLabelRenderFunction ? customLabelRenderFunction(option) : option}{unit}
            </S.DropupOption>
          )}
      </S.DropupContainer>}
      {customTriggerButton ?
        hoverTriggered ?
          <S.DropupCustomButtonWrapper ref={CustomTriggerButtonWrapperRef}>
            {customTriggerButton(toggleShowDropup)}
          </S.DropupCustomButtonWrapper>
          :
          customTriggerButton(toggleShowDropup)
        :
        <S.DropupButton onClick={toggleShowDropup}>{currentSelected}{unit}</S.DropupButton>}
    </S.DropupWrapper>
  )
}

export { Dropup as default };
